module.exports = __webpack_public_path__ + "img/welfare_default_banner.4cef4438.png";